import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js';
import { useFlags } from 'wsm-common-data';
import { selectIsTabbedLayout } from '../../../features/layoutSlice';
import { enableModernMyCarsFlag } from '../../../global-constants';
import FooterSkeleton, {
	FooterSkeletonContainerClasses
} from '../skeleton/FooterSkeleton';
import {
	useCompareVehicles,
	useFooterLayoutClasses,
	useDeviceType
} from '../../../hooks';
import Footer from './Footer';
import CompareContent from './CompareCheckbox/ModernMyCarsLabel/CompareContent';

const FooterContainer = ({
	shouldFullyRenderCard,
	useSimplifiedListing,
	...props
}) => {
	const {
		vehicle: { uuid }
	} = props;
	const flags = useFlags();
	const isDesktop = useDeviceType();
	const isTabbedLayout = useSelector(selectIsTabbedLayout);
	const compareVehicles = useCompareVehicles(uuid);
	const { selected } = compareVehicles;
	const enableModernMyCars = flags[enableModernMyCarsFlag];

	const footerContainerClasses = useFooterLayoutClasses(
		flags,
		isDesktop,
		isTabbedLayout,
		shouldFullyRenderCard
	);
	if (!shouldFullyRenderCard) {
		footerContainerClasses.push(...FooterSkeletonContainerClasses);
	}
	if (useSimplifiedListing) {
		footerContainerClasses.push('pt-0 pb-3');
	}

	return (
		<>
			{enableModernMyCars && <hr className="my-0 mx-4" />}
			<div className={setClassNames(footerContainerClasses)}>
				{shouldFullyRenderCard ? (
					<Footer {...props} {...compareVehicles} />
				) : (
					<FooterSkeleton />
				)}
			</div>

			{enableModernMyCars && isTabbedLayout && selected ? (
				<div className="w-100 pb-4 ddc-font-size-small text-center">
					<CompareContent
						selected={selected}
						isInline={!isTabbedLayout}
					/>
				</div>
			) : null}
		</>
	);
};

FooterContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool.isRequired,
	useSimplifiedListing: PropTypes.bool.isRequired,
	vehicle: PropTypes.shape({
		uuid: PropTypes.string,
		link: PropTypes.string
	}).isRequired
};

export default FooterContainer;
